module.exports = __webpack_public_path__ + "static/media/27OCHA20.5187545e.jpg";